import type { TileGraphNode } from "../core/engine/TileGraphNode/TileGraphNode.type"
import type { QuadrantBound } from "./createEntityQuadtreeEffect"

type EntityQuadtreeEffectFn<T extends TileGraphNode> = (
  subNodeList: Array<T>,
  quadrant: QuadrantBound
) => void

export default function createTileGraphNodeQuadtree<T extends TileGraphNode>(
  tpNodeList: Array<T>,
  rootQuadrantBound: QuadrantBound,
  chunkSize: number,
  effectFn: EntityQuadtreeEffectFn<T>,
): void {
  const chunksSizeX = Math.ceil(rootQuadrantBound.width / chunkSize)
  const chunksSizeY = Math.ceil(rootQuadrantBound.height / chunkSize)
  for (let chunkY = 0; chunkY < chunksSizeY; chunkY++) {
    for (let chunkX = 0; chunkX < chunksSizeX; chunkX++) {
      const quadrant = {
        x: rootQuadrantBound.x + chunkX * chunkSize,
        y: rootQuadrantBound.y + chunkY * chunkSize,
        width: chunkSize,
        height: chunkSize,
      }
      const subNodeList = getSubNodeList(tpNodeList, quadrant)
      effectFn(subNodeList, quadrant)
    }
  }
}

function getSubNodeList<T extends TileGraphNode>(
  tpNodeList: Array<T>,
  quadrant: QuadrantBound
): Array<T> {
  const { x, y, width, height } = quadrant
  const list: Array<T> = []
  for (const tpNode of tpNodeList) {
    if (tpNode.x >= x && tpNode.x < x + width && tpNode.y >= y && tpNode.y < y + height) {
      list.push(tpNode)
    }
  }
  return list
}
  